export const lang = {
  语言: "English",
  登录: "登錄",
  微信登录: "微信登錄",
  账户登录: "賬戶登錄",
  请使用微信扫描二维码登录: "請使用微信掃描二維碼登錄",
  公司版权所有北京路晨伟业仪器设备有限公司: "公司版權所有：北京路晨偉業儀器設備有限公司",
  京ICP备18062262号1: "京ICP備18062262号-1",
  设备数据: "設備數據",
  首页: "首頁",
  手动单通道: "手動單通道",
  自动单通道: "自動單通道",
  手动双通道: "手動雙通道",
  自动双通道: "自動雙通道",
  单通道带剪切力: "單通道帶剪切力",
  静力触探: "靜力觸探",
  修改密码: "修改密碼",
  退出: "退出",
  旧密码: "舊密碼",
  新密码: "新密碼",
  确认新密码: "確認新密碼",
  保存: "保存",
  取消: "取消",
  密码至少为6位: "密碼至少為6位",
  密码错误: "密碼錯誤",
  微信用户: "微信用戶",
  确定要退出吗: "確定要退出嗎？",
  新增绑定设备: "新增綁定設備",
  设备序列号: "設備序列號",
  经销商电话: "經銷商電話",
  备注: "備註",
  绑定: "綁定",
  重置: "重置",
  序列号: "序列號",
  已绑定设备: "已綁定設備",
  设备类型: "設備類型",
  绑定时间: "綁定時間",
  操作: "操作",
  解绑: "解綁",
  请输入序列号: "請輸入序列號",
  请输入经销商电话: "請輸入經銷商電話",
  请输入备注: "請輸入備註",
  确定要解绑吗: "確定要解綁嗎？",
  由斯姆捷科技有限公司提供技术支持: "收斯姆捷科技有限公司提供技術支持",
  日期: "日期",
  孔号: "孔號",
  试验时间: "試驗時間",
  截面积: "截面積",
  表面积: "表面積",
  位移点长度: "位移點長度",
  起始深度: "起始深度",
  打印: "打印",
  导出: "導出",
  删除: "刪除",
  图形: "圖形",
  详细信息: "詳細信息",
  深度: "深度",
  阻力: "阻力",
  锥尖阻力: "錐尖阻力",
  确定要删除吗: "確定要刪除嗎?",
  深度压强: "深度/壓強",
  压强: "壓強",
  全屏: "全屏",
  打印图表: "打印圖表",
  导出JPEG: "導出 JPEG",
  导出PDF: "導出 PDF",
  导出PNG: "導出 PNG",
  导出SVG: "導出 SVG",
  试验编号: "試驗編號",
  侧壁阻力: "側壁阻力",
  深度锥尖阻力: "深度/錐尖阻力",
  深度侧壁阻力: "深度/側壁阻力",
  土类型: "土類型",
  工程编号: "工程編號",
  试验深度: "試驗深度",
  运行系数: "運行係數",
  孔口高度: "孔口高度",
  地下水位: "地下水位",
  角度: "角度",
  抗剪强度: "抗剪強度",
  存在空数据: "存在空數據",
  请选择一条原状土和一条重塑土记录: "請選擇一條原狀土和一條重塑土記錄",
  角度抗剪强度: "角度/抗剪強度",
  修改成功: "修改成功",
  密码不一致: "密碼不一致",
  修改失败: "修改失敗",
  请求失败: "請求失敗!",
  请输入账号: "請輸入賬號",
  请输入密码: "請輸入密碼",
  重塑土: "重塑土",
  原状土: "原狀土",
  测缝仪: "測縫儀",
  测缝仪数据查询: "測縫儀數據查詢",
  构件: "構件",
  最大缝宽: "最大縫寬",
  最小缝宽: "最小縫寬",
  平均缝宽: "平均縫寬",
  加载中: "加載中",
  测点: "測點",
  缝宽: "縫寬",
  工程管理: "工程管理",
  增加: "增加",
  编辑: "編輯",
  测位管理: "測位管理",
  测点管理: "測點管理",
  无数据: "無數據",
  工程信息: "工程信息",
  工程名称: "工程名稱",
  开始时间: "開始時間",
  结束时间: "結束時間",
  测位信息: "測位信息",
  测位名称: "測位名稱",
  测点信息: "測點信息",
  测点名称: "測點名稱",
  请输入测点名称: "請輸入測點名稱",
  请选择设备: "請選擇設備",
  设备通道: "設備通道",
  请选择通道: "請選擇通道",
  请输入工程名称: "請輸入工程名稱",
  请输入开始日期: "請輸入開始日期",
  请输入结束日期: "請輸入結束日期",
  请输入测位名称: "請輸入測位名稱",
  测点设备: "測點設備",
  测点通道: "測點通道",
  表层: "表層",
  中: "中",
  中上: "中上",
  中下: "中下",
  底层: "底層",
  环境: "環境",
  请选择项目: "請選擇項目",
  删除成功: "刪除成功",
  保存成功: "積存成功",
  请选择测位: "請選擇測位",
  开始日期: "開始日期",
  结束日期: "結束日期",
  公司名称: "公司名稱",
  修改公司名称: "修改公司名稱",
  请选择测点: "請選擇測點",
  选择日期: "選擇日期",
  我的工程: "我的工程",
  测位列表: "測位列表",
  请选择工程: "請選擇工程",
  请至工程管理增加测位: "請至'工程管理'增加測位",
  导出峰值数据: "導出數據",
  原始数据导出见我的设备: "原始數據導出見'我的設備'",
  该测位下无测点: "該測位下無測點",
  通道: "通道",
  最新温度: "最新溫度",
  返回时间: "採集時間",
  峰值: "峰值",
  峰值时间: "峰值時間",
  谷值: "谷值",
  谷值时间: "谷值時間",
  平均值: "平均值",
  测点无数据: "測點無數據",
  项目起止: "項目起止",
  请选择日期: "請選擇日期",
  温度: "溫度",
  时间: "時間",
  温度曲线图: "溫度曲線圖",
  温差报警: "溫差報警",
  上下限报警: "上下限報警",
  每天降温报警: "每天降溫報警",
  每四小时降温报警: "每四小時降溫報警",
  温差名称: "溫差名稱",
  设置差值: "設置差值",
  通道1: "通道1",
  通道1时间: "通道1時間",
  通道1温度: "通道1溫度",
  通道2: "通道2",
  通道2时间: "通道2時間",
  通道2温度: "通道2溫度",
  上下限名称: "上下限名稱",
  通道时间: "通道時間",
  通道温度: "通道溫度",
  上限值: "上限值",
  下限值: "下限值",
  时间间隔: "時間間隔",
  平均温度: "平均溫度",
  降温速率报警与最大温度: "降溫速率報警與最大溫度",
  选择设备: "選擇設備",
  每天降温: "每天降溫",
  每四小时降温: "每四小時降溫",
  T1最大温度: "T1最大溫度",
  T2最大温度: "T2最大溫度",
  T3最大温度: "T3最大溫度",
  T4最大温度: "T4最大溫度",
  T5最大温度: "T5最大溫度",
  T6最大温度: "T6最大溫度",
  T7最大温度: "T7最大溫度",
  T8最大温度: "T8最大溫度",
  水泵绑定: "水泵綁定",
  报警间隔: "報警間隔",
  差值: "差值",
  分钟: "分鐘",
  名称: "名稱",
  开关: "開關",
  请输入开关imei: "請輸入開關imei",
  继电器1: "繼電器1",
  继电器2: "繼電器2",
  继电器3: "繼電器3",
  继电器4: "繼電器4",
  开关明细: "開關明細",
  关闭: "關閉",
  请输入温差名称: "請輸入溫差名稱",
  请选择工程名称: "請選擇工程名稱",
  请输入报警间隔: "請輸入報警間隔",
  报警间隔必须为数字值: "報警間隔必須為數字值",
  请输入差值: "請輸入差值",
  请输入上下限名称: "請輸入上下限名稱",
  创建时间: "創建時間",
  请输入名称: "請輸入名稱",
  长度15个字符: "長度15個字符",
  请选择继电器: "請選擇繼電器",
  开关imei: "開關imei",
  继电器: "繼電器",
  明细: "明細",
  请选择一条记录: "請選擇一條記錄",
  电池电量: "電池電量",
  无记录: "無記錄",
  刷新: "刷新",
  天: "天",
  未配置工程信息: "未配置工程信息",
  工程: "工程",
  测位: "測位",
  数字格式不正确: "數字格式不正確",
  时间格式不正确: "時間格式不正確",
  至: "至",
  小时: "小時",
  无线测温仪: "無線測溫儀",
  报警管理: "報警管理",
  我的设备: "我的設備",
  平均温度查询: "平均溫度查詢",
  报警记录查询: "報警記錄查詢",
  公司名称不能为空: "公司名稱不能為空",
  二维码: "二維碼",
  工程地址: "工程地址",
  请输入工程地址: "請輸入工程地址",
  测点绑定: "測點綁定",
  传感器序列号: "傳感器序列號",
  不能为空: "不能為空",
  确定要覆盖吗: "確定要覆蓋嗎?",
  已绑定: "已綁定",
  请选择: "請選擇",
  多次: "多次",
  是: "是",
  否: "否",
  其他人绑定中: "其他人綁定中",
  降温速率报警: "降溫速率報警",
  前一天: "前一天",
  后一天: "后一天",
  报警记录: "報警記錄",
  编辑名称: "編輯名稱",
  查看数据: "查看數據",
  解除绑定: "解除綁定",
  原始数据: "原始數據",
  计算结果: "計算結果",
  标定点: "標定點",
  电势: "電勢",
  计算: "計算",
  空: "空",
  请输入温度: "請輸入溫度",
  电阻率: "電阻率",
  电阻率数据查询: "電阻率數據查詢",

  WIFI打印: "WIFI列印",
  USB打印: "USB列印",
  A4打印: "A4列印",
  检测道路: "檢測道路",
  检测路段: "檢測路段",
  检测班组: "檢測班組",
  检测员: "檢測員",
  坐标: "道路號",
  道路号: "道路號",
  路幅号: "路幅號",
  里程号: "里程號",
  起始桩号: "起始樁號",
  极限差值: "極限差值",
  百米清零: "百米清零",
  上传: "上傳",
  正向累计值: "正向累計值",
  负向累计值: "負向累計值",
  正超差值: "正超差值",
  负超差值: "負超差值",
  平均速度: "平均速度",
  累计面积: "累計面積",
  平整度: "平整度",
  测试点: "測試點",
  位移: "位移",
  无地址信息: "無地址資訊",
  打印机序列号: "印表機序列號",
  请输入打印机序列号: "請輸入印表機序列號",
  确定要上传吗: "確定要上傳嗎?",
  数据上传中: "數據上傳中",
  上传成功: "上傳成功",
  型8平整度数据查询: "8型平整度數據查詢",
  型7平整度数据查询: "7型平整度數據查詢",
  次: "次",
  请选中行: "請選取中行",
  超差值: "超差值",
  打印选项: "列印選項",
  正在发送打印命令: "正在發送列印命令",
  发送打印命令成功: "發送列印命令成功",
  请配置公司名称: "請配置公司名稱",
  测试长度: " 測試長度",
  试验方法: "試驗方法",
  检测对象: "檢測物件",
  试验类型: "試驗類型",
  电位法: "電位法",
  电位滴定法: "電位滴定法",
  水泥: "水泥",
  外加剂: "外加劑",
  空白: "空白",
  硝酸银: "硝酸銀",
  氯化物: "氯化物",
  拌合物: "拌合物",
  水灰比: "水灰比",
  质量体积: "質量體積",
  上一页: "上一頁",
  下一页: "下一頁",
  运行时长: "運行時長",
  空白试验结果: "空白試驗結果",
  曲线1: "曲線1",
  曲线2: "曲線2",
  体积: "體積",
  硝酸银试验结果: "硝酸銀試驗結果",
  硝酸银试验结果1: "硝酸銀試驗結果1",
  硝酸银试验结果2: "硝酸銀試驗結果2",
  标准液体积: "標準液體積",
  标准液浓度: "標準液濃度",
  硝酸银浓度: "硝酸銀濃度",
  空白试验结果1: "空白試驗結果1",
  空白试验结果2: "空白試驗結果2",
  氯化物试验结果1: "氯化物試驗結果1",
  氯化物试验结果2: "氯化物試驗結果2",
  氯化物试验结果: "氯化物試驗結果",
  氯化物质量: "氯化物質量",
  质量百分比: "質量百分比",
  氯离子: "氯離子",
  氯离子数据查询: "氯離子數據查詢",
  氯离子计算工具: "氯離子計算工具",
  查看: "查看",
  我的测点: "我的測點",
  请至少选择一条数据: "請至少選擇一條數據",
  软化点: "軟化點",
  软化点数据查询: "軟化點數據查詢",
  小球: "小球",
  导入数据: "導入數據",
  编辑记录: "編輯記錄",
  每分钟数据: "每分鐘數據",
  必须输入数字以逗号隔开: "必須輸入數字以逗號隔開",
  请输入试验编号: "請輸入試驗編號",
  请输入时间: "請輸入時間",
  版本: "版本",
  //侯棒棒
  传感器: "感測器",
  传感器1: "感測器1",
  传感器2: "感測器2",
  传感器温度: "感測器溫度",
  传感器1温度: "感測器1溫度",
  传感器2温度: "感測器2溫度",
  传感器时间: "感測器時間",
  传感器1时间: "感測器1時間",
  传感器2时间: "感測器2時間",
  全部标为已读: "全部標為已讀",
  上限值必须为数字值: "上限值必須為數位值",
  下限值必须为数字值: "下限值必須為數位值",
  请输入上限值: "請輸入上限值",
  请输入下限值: "請輸入下限值",
  背光时长: "背光時長",
  采样间隔: "採樣間隔",
  是否开机升级: "是否開機陞級",
  请输入背光时长: "請輸入背光時長",
  请输入采样间隔: "請輸入採樣間隔",
  保存失败: "保存失敗",
  必须为数字值: "必須為數位值",
  密码为四位数字: "密碼為四比特數位",
  必须为整数: "必須為整數",
  对接公司名称: "對接公司名稱",
  t1序列号: "t1序號",
  t2序列号: "t2序號",
  t3序列号: "t3序號",
  t4序列号: "t4序號",
  t5序列号: "t5序號",
  t6序列号: "t6序號",
  t7序列号: "t7序號",
  t8序列号: "t8序號",
};
